/* ============
 * FeesReport Transformer
 * ============
 *
 * todo: add documentation here!
 */

import Transformer from './transformer';

export default class FeesReportTransformer extends Transformer {

  static fetch(item) {
    return {
      productType: item.product_type,
      internalItemNumber: item.internal_item_number,
      externalItemNumber: item.external_item_number,
      productName: item.product_name,
      producerName: item.producer_name,
      vintage: item.vintage,
      alcoholPercentage: item.alcohol_percentage,
      bottleVolume: item.bottle_volume,
      packagingType: item.packaging_type,
      corkType: item.cork_type,
      excisable: item.excisable,
      numberOfBottlesSold: item.number_of_bottles_sold,
      numberOfLitersSold: item.number_of_liters_sold,
      id: item.id,
      productId: item.product_id,
      orderProducts: item.order_products,
      number: item.number,
    };
  }

  static send() {
    return {
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/feesReport.js